import React from "react";
import moment from "moment";
import { getRoomPrice } from "../../utils/app-helpers";
import GatsbyConfig from "../../../gatsby-config.js";
import RoomCard from "./room-card";
import RoomCardBlank from "./room-card-blank";

const { siteMetadata: config } = GatsbyConfig;

export default class Lineup extends React.Component {
  getMonthlyPrice(room) {
    const { xMonths, subscriptionFee } = this;
    const { trip } = this.props.inherit;
    const tripData = config.trips[trip];
    const fullPrice = getRoomPrice(tripData, room) * 100;

    return Math.round((fullPrice + subscriptionFee) / xMonths / 2);
  }

  render() {
    const { trip, kind } = this.props.inherit;
    const tripData = config.trips[trip];
    const rooms = { ...tripData.rooms, zEmpty: {} };
    const useMaxSubMonthsCutoff = moment(
      tripData.useMaxSubMonthsCutoff,
      "MM-DD-YYYY"
    );
    const availabilityCutoff = moment(
      tripData.availabilityCutoff,
      "MM-DD-YYYY"
    );
    const today = moment(new Date());
    const maxMonths = tripData.maxSubMonths;
    let roomCards = [];
    let xMonths;

    if (today.valueOf() > useMaxSubMonthsCutoff.valueOf()) {
      let monthRemainder = 0;
      xMonths = Math.floor(availabilityCutoff.diff(today, "months", true)) + 1;
      if (xMonths > maxMonths) {
        monthRemainder = xMonths - maxMonths;
        xMonths = maxMonths;
      }
      if (availabilityCutoff.date() > today.date()) {
        monthRemainder++;
      }
    } else {
      xMonths = maxMonths;
    }
    this.xMonths = xMonths;
    this.subscriptionFee = tripData.subscriptionFee * 100;
    for (const key in rooms) {
      if (key === "zEmpty") {
        if (kind === "room") {
          roomCards.push(<RoomCardBlank key={key} trip={trip} />);
        }
        continue;
      }
      const room = rooms[key];
      if (room.hideFromBooking) continue;
      if (kind && [kind, "hybrid"].indexOf(room.kind) < 0) continue;
      const monthlyPrice = Math.round(this.getMonthlyPrice(room) / 100);

      roomCards.push(
        <RoomCard
          key={key}
          trip={trip}
          room={room}
          monthlyPrice={monthlyPrice}
        />
      );
    }
    return (
      <div className="rooms">
        <div className={`cards ${kind}-cards`}>{roomCards}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/rooms.js